export default __webpack_public_path__ + "static/media/regulatory--no-snowmobiles--g1.cfa8001f.png";